import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './PacientesNew.module.css';
import { FiPlus } from 'react-icons/fi';

const initialForm = {
  razao_social: '',
  nome_fantasia: '',
  cnpj: '',
  email: '',
  telefone: '',
  rua: '',
  numero: '',
  bairro: '',
  cidade: '',
  estado: '',
  cep: '',
};

export default function Fornecedores() {
  const [fornecedores, setFornecedores] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    fetchFornecedores();
  }, []);

  const fetchFornecedores = async () => {
    setLoading(true);
    try {
  const res = await axios.get('/fornecedores');
      setFornecedores(res.data.data || []);
    } catch (e) {
      setFornecedores([]);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
  const res = await axios.post('/fornecedores', form);
      if (res.data && res.data.data) {
        setFornecedores((prev) => [...prev, res.data.data]);
        setForm(initialForm);
        setShowForm(false);
      }
    } catch (err) {
      alert('Erro ao salvar fornecedor.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Cadastro de Fornecedores</h1>
        <p>Gerencie o cadastro e informações dos fornecedores</p>
      </div>

      <div className={styles.actions}>
        <button
          onClick={() => setShowForm(true)}
          className="formButton primary"
        >
          <FiPlus /> Novo Fornecedor
        </button>
      </div>

      {showForm && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h2>Novo Fornecedor</h2>
              <button onClick={() => setShowForm(false)} className={styles.closeButton}>×</button>
            </div>
            <form onSubmit={handleSubmit} className="form">
              <div className="formRow">
                <div className="formCol">
                  <div className="formGroup required">
                    <label className="formLabel">Razão Social</label>
                    <input name="razao_social" value={form.razao_social} onChange={handleInputChange} required className="formInput" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="formGroup required">
                    <label className="formLabel">Nome Fantasia</label>
                    <input name="nome_fantasia" value={form.nome_fantasia} onChange={handleInputChange} required className="formInput" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="formGroup required">
                    <label className="formLabel">CNPJ</label>
                    <input name="cnpj" value={form.cnpj} onChange={handleInputChange} required className="formInput" />
                  </div>
                </div>
              </div>
              <div className="formRow">
                <div className="formCol">
                  <div className="formGroup">
                    <label className="formLabel">Email</label>
                    <input name="email" type="email" value={form.email} onChange={handleInputChange} className="formInput" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="formGroup">
                    <label className="formLabel">Telefone</label>
                    <input name="telefone" value={form.telefone} onChange={handleInputChange} className="formInput" />
                  </div>
                </div>
              </div>
              <div className="formRow">
                <div className="formCol">
                  <div className="formGroup">
                    <label className="formLabel">Rua</label>
                    <input name="rua" value={form.rua} onChange={handleInputChange} className="formInput" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="formGroup">
                    <label className="formLabel">Número</label>
                    <input name="numero" value={form.numero} onChange={handleInputChange} className="formInput" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="formGroup">
                    <label className="formLabel">Bairro</label>
                    <input name="bairro" value={form.bairro} onChange={handleInputChange} className="formInput" />
                  </div>
                </div>
              </div>
              <div className="formRow">
                <div className="formCol">
                  <div className="formGroup">
                    <label className="formLabel">Cidade</label>
                    <input name="cidade" value={form.cidade} onChange={handleInputChange} className="formInput" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="formGroup">
                    <label className="formLabel">Estado</label>
                    <input name="estado" value={form.estado} onChange={handleInputChange} className="formInput" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="formGroup">
                    <label className="formLabel">CEP</label>
                    <input name="cep" value={form.cep} onChange={handleInputChange} className="formInput" />
                  </div>
                </div>
              </div>
              <div className={styles.modalFooter}>
                <button type="submit" disabled={saving} className="formButton primary">
                  {saving ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px #0001' }}>
        <thead style={{ background: '#f5f5f5' }}>
          <tr>
            <th style={{ padding: 10, textAlign: 'left' }}>Razão Social</th>
            <th style={{ padding: 10, textAlign: 'left' }}>Nome Fantasia</th>
            <th style={{ padding: 10, textAlign: 'left' }}>CNPJ</th>
            <th style={{ padding: 10, textAlign: 'left' }}>Email</th>
            <th style={{ padding: 10, textAlign: 'left' }}>Telefone</th>
            <th style={{ padding: 10, textAlign: 'left' }}>Cidade</th>
            <th style={{ padding: 10, textAlign: 'left' }}>Estado</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr><td colSpan={7} style={{ textAlign: 'center', padding: 24 }}>Carregando...</td></tr>
          )}
          {!loading && fornecedores.length === 0 && (
            <tr><td colSpan={7} style={{ textAlign: 'center', padding: 24, color: '#888' }}>Nenhum fornecedor cadastrado.</td></tr>
          )}
          {fornecedores.map(f => (
            <tr key={f.id} style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: 8 }}>{f.razao_social}</td>
              <td style={{ padding: 8 }}>{f.nome_fantasia}</td>
              <td style={{ padding: 8 }}>{f.cnpj}</td>
              <td style={{ padding: 8 }}>{f.email}</td>
              <td style={{ padding: 8 }}>{f.telefone}</td>
              <td style={{ padding: 8 }}>{f.cidade}</td>
              <td style={{ padding: 8 }}>{f.estado}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
